import React, { useState } from "react";
import { Button, Form, Input, Alert } from "antd";
import { useTranslation } from "../../i18n/LanguageContext";
// Reuse the feedback form styling (same card layout).
import "../Feedback/style.css";
import API_URL from "../../apiBase";

const RegisterOrganization = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const onFinish = async (values) => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(`${API_URL}/api/organizations/apply`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(values),
            });
            const data = await res.json().catch(() => null);
            if (!res.ok) {
                throw new Error((data && data.error) || t("org.error"));
            }
            setSubmitted(true);
            form.resetFields();
        } catch (err) {
            setError(err.message || t("org.error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-content-wrapper">
            <div className="feedback-container">
                <div className="feedback-card">
                    <h2>{t("org.title")}</h2>
                    <p className="feedback-lead">{t("org.lead")}</p>

                    {submitted && (
                        <Alert
                            className="feedback-alert"
                            type="success"
                            showIcon
                            message={t("org.success")}
                            closable
                            onClose={() => setSubmitted(false)}
                        />
                    )}

                    {error && (
                        <Alert
                            className="feedback-alert"
                            type="error"
                            showIcon
                            message={error}
                            closable
                            onClose={() => setError(null)}
                        />
                    )}

                    <Form
                        form={form}
                        name="registerOrganization"
                        onFinish={onFinish}
                        autoComplete="off"
                        size="large"
                        layout="vertical"
                        requiredMark={false}
                    >
                        <Form.Item
                            label={t("org.orgName")}
                            name="orgName"
                            rules={[
                                {
                                    required: true,
                                    message: t("org.orgName.required"),
                                },
                            ]}
                        >
                            <Input placeholder={t("org.orgName")} />
                        </Form.Item>
                        <Form.Item
                            label={t("org.contactName")}
                            name="contactName"
                            rules={[
                                {
                                    required: true,
                                    message: t("org.contactName.required"),
                                },
                            ]}
                        >
                            <Input placeholder={t("org.contactName")} />
                        </Form.Item>
                        <Form.Item
                            label={t("org.email")}
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: t("org.email.required"),
                                },
                                {
                                    type: "email",
                                    message: t("org.email.invalid"),
                                },
                            ]}
                        >
                            <Input placeholder="org@example.com" />
                        </Form.Item>
                        <Form.Item
                            label={t("org.phone")}
                            name="phone"
                            rules={[
                                {
                                    required: true,
                                    message: t("org.phone.required"),
                                },
                                {
                                    pattern: /^[+\d][\d\s()-]{6,}$/,
                                    message: t("org.phone.invalid"),
                                },
                            ]}
                        >
                            <Input placeholder="+374 XX XXX XXX" />
                        </Form.Item>
                        <Form.Item label={t("org.city")} name="city">
                            <Input placeholder={t("org.city")} />
                        </Form.Item>
                        <Form.Item label={t("org.website")} name="website">
                            <Input placeholder="https://" />
                        </Form.Item>
                        <Form.Item
                            label={t("org.description")}
                            name="description"
                        >
                            <Input.TextArea
                                rows={4}
                                placeholder={t("org.description.placeholder")}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                block
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                {t("org.submit")}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default RegisterOrganization;
